import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @author susahuang
 * @datetime 2016/4/27
 * @version 2.0.0.0
 * @class milo.ams.bindArea_v2.bindAreaCommit
 * 绑定大区<br/>
 */
import FlowEngine from '../amsRequest/flowengine';
import ams from '../common/ams';
import Cookie from '../common/cookie';
import { extend, isObject } from '../common/base';
import Login from './login';
var defaultOption = {
  /**
   * @cfg {number} iAMSActivityId AMS活动号
   */
  iAMSActivityId: -1,

  /**
   * @cfg {number} iFlowId 流程号
   */
  iFlowId: -1,

  /**
   * @cfg {number} activityId 订阅模块的id号
   */
  activityId: -1,

  /**
   * @cfg {string} 额外参数
   */
  sData: {},

  /**
   * @cfg {date} catchTime 缓存时间 只支持毫秒
   */
  catchTime: 3600000,
  modified: false
}; // sRoleInfoUrl,上云请求的地址

var getRoleInfoUrl = function getRoleInfoUrl(amsActDes, iActivityId) {
  amsActDes = amsActDes || window["ams_actdesc_".concat(iActivityId)] || {}; // var flowObj=ams_actdesc.flows['f_'+iFlowId];

  if (amsActDes.sRoleInfoUrl) {
    return "".concat(location.protocol, "//").concat(amsActDes.sRoleInfoUrl);
  }

  return '';
}; // openid转换


var getOpenToOpen = function getOpenToOpen(amsActDes, sData, option) {
  var iActivityId = option.iActivityId,
      iFlowId = option.iFlowId,
      _option$flowConfig = option.flowConfig,
      flowConfig = _option$flowConfig === void 0 ? {} : _option$flowConfig;
  var openToOpenObj = {
    oGopenidParams: {}
  };

  try {
    var flowObj = amsActDes.flows["f_".concat(iFlowId)];
    openToOpenObj.iActivityId = iActivityId;
    /*
    Step1:先判断账号类型决定是否走GOpenid相关逻辑
    */
    // 需要转换Gopenid

    if (5 == amsActDes.sAccountType) {
      openToOpenObj.oGopenidParams.needGopenid = 1;
    } // Gopenid带注册


    if (7 == amsActDes.sAccountType) {
      openToOpenObj.oGopenidParams.needGopenid = 1;
      openToOpenObj.oGopenidParams.isPreengage = 1;
    }
    /*
    Step2:托管相关逻辑
    */


    var _sData = flowConfig.sData || {};

    if (isObject(_sData.oGopenidParams)) {
      openToOpenObj.oGopenidParams = _objectSpread(_objectSpread({}, openToOpenObj.oGopenidParams), _sData.oGopenidParams);
    } // 优先取sData中的appName和targetAppId


    if (_sData.ams_targetappid_wx || _sData.ams_targetappid_qc) {
      openToOpenObj.ams_appname = _sData.ams_appname || '';
      openToOpenObj.ams_targetappid_wx = _sData.ams_targetappid_wx;
      openToOpenObj.ams_targetappid_qc = _sData.ams_targetappid_qc;
      openToOpenObj.sAMSTrusteeship = _sData.sAMSTrusteeship || 0;
    } else {
      if ('object' === _typeof(flowObj.openToOpen)) {
        // 判断是否是对象
        if (flowObj.openToOpen.targetAppId) {
          // 判断是否有值
          openToOpenObj.ams_appname = flowObj.openToOpen.appName || '';
          openToOpenObj.ams_targetappid_wx = flowObj.openToOpen.targetAppId;
          openToOpenObj.ams_targetappid_qc = flowObj.openToOpen.targetQQAppId;
          openToOpenObj.sAMSTrusteeship = amsActDes.sAMSTrusteeship || 0;
        }
      }
    }
  } catch (e) {
    console.warn && console.warn('[bindAreaCommit.getOpenToOpen]', e);
  }

  return openToOpenObj;
};

var bindArea = {
  // msg: {
  // 	'systemError': '很抱歉，系统繁忙，请稍后再试',
  // 	'unbindSuccess': '取消大区绑定成功！',
  // 	'bindSuccess': '您已经成功绑定大区！',
  // 	'modifiedSuccess': '大区信息修改成功！',
  // 	'cannotChangeSuccess': '您已绑定大区，无需重复绑定!'
  // },
  init: function init(options) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var iActivityId, iFlowId, flowConfig;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              iActivityId = options.iActivityId, iFlowId = options.iFlowId, flowConfig = options.flowConfig;
              return _context.abrupt("return", ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref) {
                var config = _ref.config,
                    flow = _ref.flow;

                var option = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultOption), config), flow), {}, {
                  iNeedAreaRole: flow.iNeedAreaRole != 0,
                  iNeedLogin: flow.iNeedLogin != 0,
                  moduleId: flow.functions[0].sExtModuleId
                });

                return option;
              }).then(function (option) {
                return _this.getBindInfo(option);
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /*
  * 查询绑定信息
  */
  getBindInfo: function getBindInfo(option) {
    return new Promise(function (resolve, reject) {
      var _option$sData = option.sData,
          sData = _option$sData === void 0 ? {} : _option$sData;
      var amsActdesc = window["ams_actdesc_".concat(option.iAMSActivityId)];
      var iNeedAreaRoleService = amsActdesc.flows["f_".concat(option.iFlowId)] && amsActdesc.flows["f_".concat(option.iFlowId)].iNeedAreaRoleService;
      sData.sServiceType = iNeedAreaRoleService || amsActdesc.sServiceType; // 如果是openid登录 赋值appid

      if (amsActdesc.sAccountType == 2 && amsActdesc.iAreaRoleAppId) {
        var _amsActdesc$iAreaRole = amsActdesc.iAreaRoleAppId,
            wx_appid = _amsActdesc$iAreaRole.wx_appid,
            qq_appid = _amsActdesc$iAreaRole.qq_appid;
        sData.appid = Cookie.get('acctype') == 'wx' ? wx_appid : qq_appid;
      }

      FlowEngine.submit({
        iActivityId: option.iAMSActivityId,
        iFlowId: option.iFlowId,
        sNeedSubmitPopDiv: undefined === option.sNeedSubmitPopDiv ? true : option.sNeedSubmitPopDiv,
        sData: sData,
        fFlowSubmitEnd: function fFlowSubmitEnd(retObj) {
          if (retObj.iRet == '0' && retObj.jData.data) {
            window["BindAreaInfo_".concat(option.moduleId)] = retObj;
            resolve({
              option: option,
              bindInfo: retObj
            });
          } else {
            retObj.errMsg = '您尚未绑定大区';
            reject(retObj);
          }
        },
        fFlowSubmitFailed: function fFlowSubmitFailed(err) {
          reject(err);
        } // 增加自定义流程失败回调，如果有传，则执行
        // 'objCustomFun': {
        // 	'101': function () {
        // 		LoginManager.login();
        // 	}
        // }

      })["catch"](function (err) {
        reject(err);
      });
    });
  },
  getRoleInfoConfig: function getRoleInfoConfig(option) {
    var iActivityId = option.iActivityId,
        iFlowId = option.iFlowId,
        flowConfig = option.flowConfig;
    return new Promise(function (resolve, reject) {
      ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref2) {
        var config = _ref2.config,
            flow = _ref2.flow;
        var amsActDes = window["ams_actdesc_".concat(iActivityId)];
        var sData = flowConfig && flowConfig.sData || {};
        var iNeedAreaRoleService = flow && flow.iNeedAreaRoleService;
        var gameId = iNeedAreaRoleService || amsActDes.sServiceType;
        sData.sServiceType = gameId;

        var rsOption = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultOption), config), flow), {}, {
          iNeedAreaRole: flow.iNeedAreaRole != 0,
          iNeedLogin: flow.iNeedLogin != 0,
          sRoleInfoUrl: getRoleInfoUrl(amsActDes, iActivityId),
          openToOpen: getOpenToOpen(amsActDes, sData, option),
          gameId: gameId,
          moduleId: flow.functions[0].sExtModuleId
        });

        if (flow.iNeedLogin) {
          var LoginManager = new Login();
          LoginManager.checkLogin().then(function () {
            resolve(rsOption);
          })["catch"](function (err) {
            reject(err);
          });
        } else {
          resolve(rsOption);
        }
      })["catch"](function (err) {
        reject(err);
      });
    });
  },

  /*
         ** 更改绑定大区功能
         */
  bind: function bind(option) {
    return new Promise(function (resolve, reject) {
      var _option$sData2 = option.sData,
          sData = _option$sData2 === void 0 ? {} : _option$sData2;
      var amsActdesc = window["ams_actdesc_".concat(option.iActivityId)];
      var iNeedAreaRoleService = amsActdesc.flows["f_".concat(option.iFlowId)] && amsActdesc.flows["f_".concat(option.iFlowId)].iNeedAreaRoleService;
      sData.sServiceType = iNeedAreaRoleService || amsActdesc.sServiceType;
      sData.iNeedSubmitDataPlatid = true; // 如果是openid登录 赋值appid

      if (amsActdesc.sAccountType == 2 && amsActdesc.iAreaRoleAppId) {
        var _amsActdesc$iAreaRole2 = amsActdesc.iAreaRoleAppId,
            wx_appid = _amsActdesc$iAreaRole2.wx_appid,
            qq_appid = _amsActdesc$iAreaRole2.qq_appid;
        sData.appid = Cookie.get('acctype') == 'wx' ? wx_appid : qq_appid;
      }

      var tRoleInfo = option.roleInfo || {};
      extend(sData, {
        user_area: tRoleInfo.area || '',
        user_roleId: tRoleInfo.roleId || '',
        user_roleName: encodeURIComponent(tRoleInfo.roleName || ''),
        user_areaName: tRoleInfo.areaname || '',
        user_roleLevel: tRoleInfo.rolelevel || '',
        user_checkparam: tRoleInfo.checkparam || '',
        user_md5str: tRoleInfo.md5str || '',
        user_sex: tRoleInfo.rolesex || '',
        user_platId: tRoleInfo.platid || '',
        user_partition: tRoleInfo.partition || ''
      });
      FlowEngine.submit({
        iActivityId: option.iActivityId,
        // AMS活动号
        iFlowId: option.iFlowId,
        sNeedSubmitPopDiv: 'undefined' === typeof option.sNeedSubmitPopDiv ? true : option.sNeedSubmitPopDiv,
        isBindAreaFlow: true,
        // 是否是绑定大区流程，如果是的话，后面flowengine就不再弹框查角色
        sData: sData,
        fFlowSubmitEnd: function fFlowSubmitEnd(retObj) {
          if (retObj.jData.data !== undefined) {
            window["BindAreaInfo_".concat(amsActdesc.iAreaRoleModId)] = retObj;
          }

          resolve({
            option: option,
            bindInfo: retObj
          });
        },
        fFlowSubmitFailed: function fFlowSubmitFailed(err) {
          reject(err);
        }
      })["catch"](function (err) {
        reject(err);
      });
    });
  }
};
export default bindArea;